export function modelingTimeString (time, digit = 3) {
  if (!time) {
    return time;
  }
  const existDecimalPoint = `${time}`.includes('.');
  if (existDecimalPoint) {
    const timeArr = `${time}`.split('.');
    return `${timeArr[0]}.${(timeArr[1] + '000').slice(0, digit)}`;
  } else {
    return `${time}.000`;
  }
}
